const ADMIN_TRACKING_EVENTS = {
  admin: {
    searchButton: {
      clicked: true,
    },
    searchResult: {
      clicked: true,
      autoOpened: true,
    },
    mockButton: {
      clicked: true,
    },
    supportMockButton: {
      clicked: true,
    },
    rogbot: {
      saveButtonClicked: true,
    },
    partnerAdmins: {
      saveButtonClicked: true,
    },
    locProducts: {
      trialsButtonClicked: true,
    },
    locationAutomations: {
      toggleClicked: true,
    },
    orgDetails: {
      redirectSalesforceClicked: true,
    },
    orgUsers: {
      saveButtonClicked: true,
    },
    locationDetails: {
      paymentPastDueClicked: true,
      reviewGoalChanged: true,
      noResendIntervalDaysChanged: true,
    },
    orgSettings: {
      blockMarketingEmailsClicked: true,
      orgNameOnInvitationClicked: true,
      afterHoursResponder: true,
    },
    tools: {
      phoneLookupClicked: true,
      deleteConversationClicked: true,
      phoneTransferFinalized: true,
    },
    search: {
      subMenuSearched: true,
    },
    onboarding: {
      progressCircleClicked: true,
    },
  },
};

export default ADMIN_TRACKING_EVENTS;
